
import { supabase } from "@/lib/supabase";
import { User } from "@supabase/supabase-js";

export const saveDemoRequestToDatabase = async (user: User, demoDataJson: string) => {
  try {
    const demoData = JSON.parse(demoDataJson);
    
    if (!demoData || !demoData.formValues) {
      console.error("Invalid demo request data");
      return null;
    }
    
    const { formValues, userRegion } = demoData;
    
    // Save the request to the database
    const { data: requestData, error: requestError } = await supabase
      .from("refund_requests")
      .insert({
        user_id: user.id,
        merchant: formValues.merchant,
        product: formValues.merchant,
        amount: formValues.amount ? parseFloat(formValues.amount) : 0,
        currency: formValues.currency,
        issue: formValues.issue,
        order_number: formValues.orderNumber,
        status: "pending",
        region: userRegion,
      })
      .select();
      
    if (requestError) {
      console.error("Error saving demo request to database:", requestError);
      return null;
    }
    
    // Save the user message
    const userMessageInsert = await supabase.from("messages").insert({
      refund_request_id: requestData[0].id,
      sender_type: "user",
      content: formValues.issue,
    });
    
    if (userMessageInsert.error) {
      console.error("Error saving user message:", userMessageInsert.error);
    }
    
    // Save the AI response if it exists
    if (demoData.aiResponse) {
      const aiMessageInsert = await supabase.from("messages").insert({
        refund_request_id: requestData[0].id,
        sender_type: "ai",
        content: demoData.aiResponse,
        tone: demoData.tone || "professional",
        metadata: {
          legalContext: demoData.legalContext || null
        }
      });
      
      if (aiMessageInsert.error) {
        console.error("Error saving AI message:", aiMessageInsert.error);
      }
    }
    
    // Clear the demo data from session storage
    sessionStorage.removeItem('demoRefundRequest');
    
    return requestData[0];
  } catch (error) {
    console.error("Error processing demo request:", error);
    return null;
  }
};
